var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosedWorkOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20.25V16.1875C18.5 14.6555 18.5 13.8894 18.024 13.4135C17.5481 12.9375 16.782 12.9375 15.25 12.9375L12 20.25L8.75 12.9375C7.21793 12.9375 6.4519 12.9375 5.97595 13.4135C5.5 13.8894 5.5 14.6555 5.5 16.1875V20.25",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.5625L11.5938 17.8125L12 19.0312L12.4062 17.8125L12 14.5625ZM12 14.5625L11.1875 12.9375H12.8125L12 14.5625Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 7.65625V6.84375C14.8438 5.2732 13.5706 4 12 4C10.4294 4 9.15625 5.2732 9.15625 6.84375V7.65625C9.15625 9.22681 10.4294 10.5 12 10.5C13.5706 10.5 14.8438 9.22681 14.8438 7.65625Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedWorkOrder);
export default __webpack_public_path__ + "static/media/closedWorkOrder.6d2edcaf823413ca8e70f2b57f561b30.svg";
export { ForwardRef as ReactComponent };